/**
 * Komunikaty godzinowe.
 *
 * Na tym etapie moduł tylko układa treść komunikatu i wskazuje, gdzie będzie
 * leżał plik audio oraz kiedy przypada następna emisja. Generator audio (TTS
 * lub nagrania lektora) i scheduler po stronie serwera emisyjnego podepną się
 * pod te same funkcje.
 */

import { RADIO_STATION } from './radio.config';
import { RADIO_FOLDERS } from './radioLayout';

const HOURS: readonly string[] = [
  'północ',
  'pierwsza',
  'druga',
  'trzecia',
  'czwarta',
  'piąta',
  'szósta',
  'siódma',
  'ósma',
  'dziewiąta',
  'dziesiąta',
  'jedenasta',
  'dwunasta',
  'trzynasta',
  'czternasta',
  'piętnasta',
  'szesnasta',
  'siedemnasta',
  'osiemnasta',
  'dziewiętnasta',
  'dwudziesta',
  'dwudziesta pierwsza',
  'dwudziesta druga',
  'dwudziesta trzecia',
];

/** Komunikaty z charakterem dla wybranych godzin; pozostałe dostają wersję neutralną. */
const SPECIAL_ANNOUNCEMENTS: Readonly<Record<number, string>> = {
  0: `Jest północ. Jutro już jest dzisiaj. ${RADIO_STATION.name}.`,
  22: `Jest dwudziesta druga. Świat może już dzisiaj dać sobie spokój. ${RADIO_STATION.name}.`,
};

const normalizeHour = (hour: number): number => ((Math.trunc(hour) % 24) + 24) % 24;

/** Godzina słownie, np. `16` → „szesnasta". */
export function hourToWords(hour: number): string {
  return HOURS[normalizeHour(hour)];
}

/** Treść komunikatu dla pełnej godziny, np. „Jest godzina szesnasta. Słuchasz Radia Adamowo." */
export function buildTimeAnnouncement(hour: number): string {
  const normalized = normalizeHour(hour);
  return (
    SPECIAL_ANNOUNCEMENTS[normalized] ??
    `Jest godzina ${hourToWords(normalized)}. Słuchasz Radia Adamowo.`
  );
}

/** Ścieżka pliku audio komunikatu, np. `/radio/time-announcements/16.mp3`. */
export function getTimeAnnouncementAudioUrl(hour: number): string {
  const file = String(normalizeHour(hour)).padStart(2, '0');
  return `/${RADIO_FOLDERS.timeAnnouncements.dir}/${file}.mp3`;
}

/** Najbliższa pełna godzina po `from` - moment następnego komunikatu. */
export function getNextTimeAnnouncementAt(from: Date = new Date()): Date {
  const next = new Date(from);
  next.setHours(next.getHours() + 1, 0, 0, 0);
  return next;
}
